import { Component, Input, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogTitle,
  MatDialogActions
} from "@angular/material/dialog";
import { VisitTypeStore } from "@app/services/store/visit-type-store";
import { VisitType } from "@app/models/rest/visit-type";
import { Store } from "@ngrx/store";
import { Router } from "@angular/router";
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { MatIcon } from "@angular/material/icon";
import { MatFormField, MatLabel, MatError } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-visit-type-add",
  templateUrl: "./visit-type-add.component.html",
  styleUrls: ["./visit-type-add.component.scss"],
  imports: [
    MatDialogTitle,
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
    MatError,
    MatDialogActions,
    MatButton,
    TranslatePipe
  ]
})
export class VisitTypeAddComponent {
  visitTypeStore = inject(VisitTypeStore);
  protected store = inject<Store<any>>(Store);
  protected dialog = inject(MatDialog);
  protected router = inject(Router);
  dialogRef = inject<MatDialogRef<VisitTypeAddComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  visitForm = new UntypedFormGroup({
    DescriptionFormControl: new UntypedFormControl("")
  });

  @Input()
  visitType: VisitType;

  onCancelClick() {
    this.dialogRef.close();
  }

  getErrorMessage(controlName: string) {
    console.log(this.visitForm.controls[controlName].errors);
    console.log("get error");
    return this.visitForm.controls[controlName].errors.server;
  }

  addVisitType(): void {
    const visitType: VisitType = new VisitType();

    visitType.description =
      this.visitForm.controls["DescriptionFormControl"].value;

    this.visitTypeStore.create(visitType).subscribe(
      (value) => {
        console.log("success");
        this.dialogRef.close({ success: true });
      },
      (error) => {
        console.log("error");
        console.log(error);
        // alert(error.error.message)
      }
    );
  }
}
